export default {
  ALL: 'all',
  IMPORTED: 'imported',
  NON_IMPORTED: 'non-imported',
};



// WEBPACK FOOTER //
// ./src/variables/skistarImportStatus.js